import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=8f222e18&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f222e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f222e18')) {
      api.createRecord('8f222e18', component.options)
    } else {
      api.reload('8f222e18', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=8f222e18&scoped=true&", function () {
      api.rerender('8f222e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22iLSi91dX5R6/JS/comp/Voucher-Unit.vue"
export default component.exports